/* eslint-disable no-nested-ternary */
import { useActionButtonContext } from '@aibees/elephant/context/action-button-context';
import { useSaveRecord } from '@aibees/elephant/hooks/use-save-record';
import { SearchType } from '@aibees/elephant/types';
import { useNotify } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { LoadingButton } from '@mui/lab';
import { ButtonProps } from '@mui/material';
import { memo, useCallback } from 'react';
import { ActionButton } from '../action-button';
import { useIsPeopleUnlockButtonLoading } from './hooks/use-is-people-unlock-button-loading';
import * as Styled from './styles';
import type { PeopleUnlockProps as Props } from './types';

export const PeopleUnlock = memo(({ className, item, fullWidth }: Props) => {
  const workspace = useWorkspace();
  const notify = useNotify();
  const saved = !!item?.saved;
  const { addProcessingItems } = useActionButtonContext();
  const { mutateAsync } = useSaveRecord(SearchType.People);

  const { saving } = useIsPeopleUnlockButtonLoading(item);

  const onClick: ButtonProps['onClick'] = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      if (item?.id) {
        addProcessingItems({
          id: item.id,
          type: 'SAVING',
        });
        mutateAsync({
          kind: 'ADD',
          ids: [item.id],
          overwriteOwner: false,
          user: workspace?.user,
          labels: [],
        }).then(() => {
          notify.success('Contact Successfully Saved.');
        });
      }
    },
    [item?.id, addProcessingItems, mutateAsync, workspace?.user, notify]
  );

  return (
    <Styled.Wrapper className={classnames('PeopleUnlock', className)}>
      {!saved ? (
        <LoadingButton
          className={classnames('CompanySave', className)}
          variant="contained"
          color="primary"
          size={'small'}
          onClick={onClick}
          fullWidth={fullWidth}
        >
          {saving ? 'Saving...' : 'Save'}
        </LoadingButton>
      ) : (
        <ActionButton
          item={item}
          searchType={SearchType.People}
          fullWidth={fullWidth}
        />
      )}
    </Styled.Wrapper>
  );
});

PeopleUnlock.displayName = 'PeopleUnlock';
